<template>
  <div>
    <div class="row no-gutters" role="list" v-if="!slides">
      <div class="col-6 col-md-4 col-lg-3 col-xl-2 p-1 mb-1" v-for="(c, index) in categorias" :key="index" role="listitem">
        <a href="javascript:" class="shadow-sm cardapio-card text-decoration-none" :class="{'active': c.id_categoria === selCategoria}"
           @click="toggleCategoria(c)" :title="c.nome_categoria">
          <div>
            <img :src="`${base_cdn}/lecard-corporativo/icones/${c.slug || 'default'}-light.svg`" class="img-light" alt="Ícone" style="width: 22px">
            <img :src="`${base_cdn}/lecard-corporativo/icones/${c.slug || 'default'}.svg`" class="img-dark" alt="Ícone" style="width: 22px">
            <h4 class="text-categoria">{{c.nome_categoria}}</h4>
          </div>
        </a>
      </div>
    </div>
    <div class="swiper-container slide-categorias" v-show="slides">
      <div class="swiper-wrapper">
        <div class="swiper-slide text-center" v-for="(c, index) in categorias" :key="index">
          <a href="javascript:" class="link-cardapio" @click="$emit('openCategoria', c)" :title="c.nome_categoria">
            <div class="cardapio-card" :class="{'active': c.id_categoria === selCategoria}">
              <div>
                <img :src="`${base_cdn}/lecard-corporativo/icones/${c.slug || 'default'}-light.svg`" class="img-light" alt="Ícone" style="width: 22px">
                <img :src="`${base_cdn}/lecard-corporativo/icones/${c.slug || 'default'}.svg`" class="img-dark" alt="Ícone" style="width: 22px">
                <h4 class="text-categoria">{{c.nome_categoria}}</h4>
              </div>
            </div>
          </a>
        </div>
      </div>
      <div class="btn btn-secondary sw-prev">
        <i class="fa fa-angle-left"></i>
      </div>
      <div class="btn btn-secondary sw-next">
        <i class="fa fa-angle-right"></i>
      </div>
    </div>
  </div>
</template>

<script>
  import Swiper from 'swiper'
  import 'swiper/dist/css/swiper.css'

  export default {
    name: "Categorias",
    props: ['categorias', 'selCategoria', 'slides'],
    data() {
      return {
        url: '',
        swiper: null
      }
    },

    methods: {
      toggleCategoria(c) {
        this.$emit('openCategoria', c);
        this.slideTo(c.id_categoria);
      },

      slideTo(id) {
        setTimeout(() => {
          const index = this.categorias.findIndex(c => c.id_categoria === id);
          if (index !== -1) { this.swiper.slideTo(index); }
        }, 250);
      }
    },

    mounted() {
      this.url = this.origin === '5' ? '/' + this.$store.state.empresa.dominio_delivery : '';

      this.swiper = new Swiper('.slide-categorias', {
        slidesPerView: 'auto',
        a11y: false,
        observer: true,
        slidesOffsetBefore: 60,
        slidesOffsetAfter: 52,
        navigation: {
          nextEl: ".sw-next",
          prevEl: ".sw-prev",
        },
      });
    }
  }
</script>

<style scoped>
  .cardapio-card {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 8px;
    position: relative;
    width: 100%;
    height: 92px;
    overflow: hidden;
    border: 1px solid #e9e9e9;
    border-radius: 12px;
    font-weight: bold;
    text-align: center;
    background-color: #ffffff;
    color: #343a40;
    text-decoration: none;
  }

  .cardapio-card .img-light {
    display: none;
  }

  .swiper-slide .cardapio-card {
    background-color: #DBDCDE;
  }

  .cardapio-card.active {
    background-color: var(--dark);
    color: #ffffff;
  }

  .cardapio-card.active .img-light {
    display: inline-block;
  }

  .cardapio-card.active .img-dark {
    display: none;
  }

  .text-categoria {
    margin: 4px 0 0 0;
    font-size: 12px;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    max-height: 30px;
    overflow: hidden;
  }

  .swiper-container {
    width: 100%;
  }

  .swiper-slide {
    width: auto;
    font-size: 14px;
  }

  .swiper-slide .link-cardapio {
    text-decoration: none;
    width: 110px;
    padding-right: 6px;
    display: block;
  }

  .swiper-container .btn {
    z-index: 2;
    width: 42px;
    height: 42px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    position: absolute;
    top: 28%;
  }

  .sw-prev {
    left: 5px;
  }

  .sw-next {
    right: 5px;
  }
</style>
